<script>
  //import regions from '@/data.js'
  import regions from '../../static/js/data.js'
  import regionstr from '../../static/js/datatr.js'
  export default {
    name: 'RegionSelect',
    props: {
      country: String,
      region: String,
      defaultRegion: String,
      countryName: Boolean,
      regionName: Boolean,
      className: String,
      shortCodeDropdown: Boolean,
      placeholder: {
        type: String,
        default: 'Select Region'
      },
      disablePlaceholder: {
        type: Boolean,
        default: false
      },
      removePlaceholder: {
        type: Boolean,
        default: false
      },
      usei18n: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      shownRegions: [],
      regions,
      ran: false,
      regionsLang : [],
      isCountry:false
    }),
    mounted() {
      if (this.country) {

        let countryList = this.regionsLang.filter((region) => {
          if(region.countryName==this.country){
            this.isCountry=true
             this.getRegionWithCountry()
          }
        })
        
      }
    },
    computed: {
      name() {
        return this.name
      },
      value() {
        return this.region
      },
      valueType() {
        return this.regionName ? 'name' : 'shortCode'
      }
    },
    created(){
        this.$root.$moment.locale(this.$ml.current);
        if(this.$ml.current=="tr"){
          this.regionsLang=regionstr
        }else{
          this.regionsLang=regions
        }
    },
    methods: {
      onChange(region) {
        this.$emit('input', region)
        this.$emit('changeCity', region)
      },
      getRegionWithCountry(country) {
        country = country || this.country
        let countryRegions = this.regionsLang.find((elem) => {
          if(elem.countryName==this.country){
            this.isCountry=true
          }
          if (this.countryName) {
            return elem.countryName === country
          } else {
            return elem.countryShortCode === country
          }
        }).regions
        if (this.$i18n && this.usei18n) {
          countryRegions = countryRegions.map((region) => {
            let localeRegion = Object.assign({ }, region)
            localeRegion.name = this.$t(region.name)
            return localeRegion
          })
          countryRegions.sort((region1, region2) => {
            return (region1.name > region2.name) ? 1 : -1
          })
        }
        this.shownRegions = countryRegions
        if (this.disablePlaceholder && this.ran) {
          this.onChange(this.shownRegions[0][this.valueType])
        }
        if (this.removePlaceholder) {
          this.onChange(this.shownRegions[0][this.valueType])
        }
        this.ran = true
      }
    },
    watch: {
      country(newVal, oldVal) {
        if (oldVal !== '') {
          this.onChange('')
        }
        if (this.country) {
          this.getRegionWithCountry()
        } else {
          this.shownRegions = []
        }
      }
    }
  }
</script>

<template>
  <select @change="onChange($event.target.value)" :class="className">
    <option v-if="!disablePlaceholder && !removePlaceholder" value="">{{ placeholder }}</option>
    <option v-if="disablePlaceholder && !removePlaceholder" value="" disabled selected>{{ placeholder }}</option>
    <option :value="region" v-if="!isCountry && region!=''" selected>{{ region }}</option>
    <option v-for="(place, index) in shownRegions" v-bind:key="index" :value="place[valueType]" :selected="region === place[valueType]">{{shortCodeDropdown ? place.shortCode : place.name}}</option>
  </select>
</template>
